<template>
  <section>
    <v-dialog
      v-model="isShow"
      width="400px">
      <div class="dialog-container">
        <div class="dialog-header">
          <span>{{title}}</span>
        </div>
        <div class="dialog-body">
          <template v-if="step == 1">
            <div class="tips">Are you sure to unlink this account from AlipayHK ID “{{ali_id}}”?</div>
          </template>

          <template v-if="step == 2">
            <div class="tips">The account is no longer linked to AlipayHK. </div>
          </template>
        </div>
        <div class="dialog-footer">
          <template v-if="step == 1">
            <v-button
              class="btn"
              @click="handleCancel">Cancel</v-button>
            <v-button
              class="btn"
              @click="handleContinue">Continue</v-button>
          </template>

          <template v-if="step == 2">
            <v-button
              class="success"
              @click="handleDone">OK</v-button>
          </template>
        </div>
      </div>
    </v-dialog>
  </section>
</template>

<script>
import {aliUnbind} from '@/api/account'
export default {
  name: 'SendVerfication',
  props:{
    ali_id:{
      type: String,
      default: ''
    }
  },
  data(){
    return{
      isShow: false,
      step: 1,
    }
  },

  computed:{
    title(){
      return this.step == 1? 'Unlink AlipayHK' : 'AlipayHK Unlinked'
    }
  },

  methods:{
    changeDialog(){
      this.isShow = !this.isShow
    },

    handleCancel(){
      this.step = 1
      this.changeDialog()
    },

    handleContinue(){
      this.network().aliUnbind()
    },

    handleDone(){
      this.handleCancel()
      this.$emit('update')
    },

    network() {
      return {
        aliUnbind: async () => {
          let params = {
            open_id: this.ali_id
          }
          const {data} = await aliUnbind(params)
          if(data.code === 1000){
            this.step += 1
          }
        }
      }
    }
  }
}
</script>

<style scoped lang="scss">
::v-deep .el-dialog{
    box-sizing: border-box;
    border-radius: 6px;
  }
  .dialog-container {
    .dialog-header {
      padding: 16px;
      background: #F6F8FA;
      border-bottom: 1px solid #E1E4E8;
      border-radius: 6px 6px 0 0;
      span{
        font-style: normal;
        font-weight: 600;
        font-size: 14px;
        line-height: 20px;
        display: flex;
        align-items: center;
        color: #1B1F23;
        flex: none;
        order: 0;
        align-self: stretch;
        flex-grow: 0;
        /*margin: 10px 0px;*/
      }
    }
    .dialog-body{
      padding: 20px 15px;
      .tips{
        color: #24292E;
      }
    }
    .dialog-footer {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 15px;
      padding-top: 0;
      .el-button{
        background: #FAFBFC;
        border: 1px solid rgba(27, 31, 35, 0.15);
        box-sizing: border-box;
        box-shadow: 0px 1px 0px rgba(27, 31, 35, 0.04);
        border-radius: 6px;
        font-weight: 600;
        font-family: 'Inter';
      }
      .success{
        background: #2EA44F;
        color: #FFFFFF;
        width: 100%;
      }
      .btn{
        color: #24292E;
      }
    }
  }
</style>
